import React, { useState } from 'react';
import { Modal, Upload, Button, message } from 'antd';
import type { UploadFile, UploadProps, ModalProps } from 'antd';
import { adaptSize } from '../../../utils/remAdapter';
import { submitResume, validateResumeFile } from '../../../api/recruitmentApi';
import './RecruitmentModal.less'

interface RecruitmentModalProps {
  position: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
message.config({
  top: `calc(50% - ${adaptSize(28)}px)`,
})
const RecruitmentModal: React.FC<RecruitmentModalProps> = ({
  position,
  open,
  onOpenChange,
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [loading, setLoading] = useState(false);
  const handleOk = async () => {
    if (fileList.length === 0) {
      message.warning('请先上传简历');
      return;
    }
    setLoading(true);

    const file = fileList[0].originFileObj;
    if (!file) {
      message.error('文件获取失败');
      return;
    }

    try {
      setLoading(true);
      message.loading({ content: '正在提交简历...', key: 'submit', duration: 0, className: "my-message-antd" });

      // 调用接口提交简历
      const result = await submitResume({
        position,
        resumeFile: file,
      });

      message.success({ content: '感谢您的投递，我们会在审核后安排人事专员与您联系', key: 'submit', duration: 2, className: "my-message-antd" });

      // 关闭弹窗并重置表单
      setTimeout(() => {
        onOpenChange(false);
        setFileList([]);
      }, 500);

    } catch (error: any) {
      message.error({
        content: error.message || '简历投递失败，请稍后重试',
        key: 'submit',
        duration: 3,
      });
      console.error('投递失败:', error);
    } finally {
      setLoading(false);
    }

  };

  const handleCancel = () => {
    // 如果正在提交，不允许关闭
    if (loading) {
      message.warning('正在提交中，请稍候...');
      return;
    }
    onOpenChange(false);
    setFileList([]);
  };
  const styles: ModalProps['styles'] = {
    mask: {
      background: 'transparent',
    },
    container: {
      borderRadius: 0,
      backgroundColor: '#FFF',
    },
    header: {
      borderRadius: 0,
      fontSize: adaptSize('28px'),
      color: '#333',
      height: adaptSize('98px'),
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
      marginBottom: 0,
    },
    body: {
      paddingTop: adaptSize('24px'),
    },
    footer: {
      padding: '0',
    },
  };
  const uploadProps: UploadProps = {
    name: 'file',
    multiple: false,
    fileList,
    beforeUpload: (file) => {
      // 使用封装的验证方法
      const validation = validateResumeFile(file);

      if (!validation.valid) {
        message.error(validation.error);
        return Upload.LIST_IGNORE;
      }

      return false; // 阻止自动上传
    },
    onChange(info) {
      setFileList(info.fileList);
    },
    onRemove() {
      setFileList([]);
    },
  };

  return (
    <Modal
      title="投递简历"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      width={adaptSize('569px')}
      centered
      styles={styles}
      footer={[
        <Button key="submit" disabled={fileList.length === 0} type="primary" loading={loading} onClick={handleOk}
          styles={{ root: { backgroundColor: fileList.length === 0 ? 'rgba(51, 51, 51, 0.5)' : '#333', color: '#fff', borderRadius: '999px', fontSize: adaptSize('12px'), width: adaptSize('96px'), height: adaptSize('40px') } }}>
          确认投递
        </Button>]}
    >
      {/* 投递岗位 */}
      <div className='modal-content-item'>
        <div className='modal-content-title'>投递岗位
        </div>
        <div className='modal-content-content'>
          {position}
        </div>
      </div>

      {/* 上传简历 */}
      <div className='modal-content-item'>
        <div className='modal-content-title modal-content-title-file'>
          上传简历
        </div>
        <div>
          <Upload {...uploadProps}>
            <Button className='upload-btn'>{fileList.length?'重新上传':'点击上传'}</Button>
          </Upload>
        </div>

      </div>
    </Modal>
  );
};

export default RecruitmentModal;